import { taxIncluded, numberLocale } from "@/lib/money";

const fmt = (n) => new Intl.NumberFormat(numberLocale(), { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(n) || 0);

/** Live breakdown of a tax-inclusive amount: collected = revenue (ex-tax) + tax,
 *  then minus any platform/gateway fee = net received. */
export default function TaxSplit({ amount, rate, enabled, taxName = "GST", fee = 0, testid = "tax-split" }) {
  const total = Number(amount) || 0;
  if (total <= 0) return null;
  const sym = window.__ACTIVE_CURRENCY_SYMBOL__ || "";
  const tax = enabled ? taxIncluded(total, rate) : 0;
  const revenue = Math.round((total - tax) * 100) / 100;
  const feeAmt = Number(fee) || 0;
  const pct = `${Math.round((Number(rate) || 0) * 10000) / 100}%`;
  return (
    <div className="rounded-lg border border-[#1f1f1f] bg-[#0a0a0a] px-3 py-2 text-xs flex flex-wrap items-baseline gap-x-2 gap-y-1" data-testid={testid}>
      <span className="text-zinc-500">Collected</span>
      <span className="font-mono text-zinc-100">{sym}{fmt(total)}</span>
      <span className="text-zinc-600">=</span>
      <span className="text-zinc-500">Revenue</span>
      <span className="font-mono font-semibold text-emerald-300" data-testid={`${testid}-revenue`}>{sym}{fmt(revenue)}</span>
      <span className="text-zinc-600">+</span>
      <span className="text-zinc-500">{enabled ? `${taxName} ${pct}` : `${taxName} (none)`}</span>
      <span className="font-mono text-amber-300" data-testid={`${testid}-tax`}>{sym}{fmt(tax)}</span>
      {feeAmt > 0 && (
        <>
          <span className="text-zinc-700 mx-1">·</span>
          <span className="text-zinc-500">after {sym}{fmt(feeAmt)} fee, net received</span>
          <span className="font-mono text-emerald-300">{sym}{fmt(Math.max(0, revenue - feeAmt))}</span>
        </>
      )}
    </div>
  );
}
